import React from "react";
import FAQSection from "../Faqs";
import { useTranslation } from "react-i18next";

const WheatBagFaqs = () => {
  const { t } = useTranslation();

  const WBfaqs = t("wheatBagPage.wheatBagFaqs.faqs", { returnObjects: true });

  return (
    <div>
      {/* Include the FAQSection component with specific FAQs */}
      <FAQSection faqs={WBfaqs} title={t("wheatBagPage.wheatBagFaqs.title")} />
    </div>
  );
};

export default WheatBagFaqs;
